import { AWebsocketState } from "./AWebsocketState";
import { ConnectingState } from "./ConnectingState";

export class InactiveState extends AWebsocketState {
  private offVisibility?: () => void;

  override enter(): void {
    this.offVisibility = this.client.getVisibility().onChange(() => {
      if (!this.client.getVisibility().isHidden()) {
        this.connect();
      }
    });
  }

  override exit(): void {
    this.offVisibility?.();
    this.offVisibility = undefined;
  }

  override connect(): void {
    if (!this.client.shouldConnect()) {
      console.log("InactiveState: auth invalid, not reconnecting");
      return;
    }
    this.client.openFreshSocket();
    this.client.setState(new ConnectingState(this.client));
  }
}
